import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary'
import { CarsListPage } from '@features/cars/components/CarsListPage'
import { hasPermission } from '@features/rbac/permissions'
import { createFileRoute } from '@tanstack/react-router'
import { redirect } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { Suspense } from 'react'

export const Route = createFileRoute('/_layout/cars/all')({
    beforeLoad: () => {
        if (!hasPermission('cars.manage')) {
            throw redirect({ to: '/unauthorised' })
        }
    },
    component: RouteComponent,
    staticData: {
        crumb: {
            label: 'All Cars',
        }
    }
})

function RouteComponent() {
    return (
        <QueryErrorBoundary title="Failed to load cars">
            <Suspense fallback={<LoadingIndicator resource="cars" />}>
                <CarsListPage />
            </Suspense>
        </QueryErrorBoundary>
    )
}
